import * as d3 from "d3";
import $ from 'jquery';
import { addCommas, genderTooltip, downloadData } from './helpers';
import * as axios from 'axios';
import { ab109bars } from './ab109bars.js'

var margin = { top: 20, right: 30, bottom: 130, left: 50 },
    width = 960 - margin.left - margin.right,
    height = 475 - margin.top - margin.bottom;

var parseTime = d3.timeParse("%Y-%m-%d");

const pageWidth = window.innerWidth

const bisectDate = d3.bisector(function (d) {
    return d.date;
}).left;

var x = d3.scaleTime().range([0, width]);
var y = d3.scaleLinear().range([height, 0]);
var color = d3.scaleOrdinal(["#DAD9D5", "#EF4136", "#BCBDBC", "#4D4E56", "#231F20"]);

var xAxis = d3.axisBottom(x).tickFormat(d3.timeFormat("%b %Y"))
    .ticks(5)

var yAxis = d3.axisLeft(y).ticks(5);

var line = d3.line()
    .x(function (d) { return x(d.date); })
    .y(function (d) { return y(d.value); });

var svg = d3.select("#ab109-chart").append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)

var g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

ab109bars()

const ab109Data = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
    .then(content => {

        const justData = content.data

        const csv = d3.csvParse(justData)

        const aobdata = csv.filter(d => d.subgroup == "N3 Partially Sentenced" || d.subgroup == "Parole Revocation 3000.08 FPC" || d.subgroup == "PRCS Revocation 3455" || d.subgroup == "Flash Incarceration 3454" || d.subgroup == "County Sentenced N3")

        aobdata.forEach(function (d) {
            if (d.subgroup == "Flash Incarceration 3454") { d.subgroup = "Violación de supervisión: encarcelamiento “flash”" }
            else if (d.subgroup == "N3 Partially Sentenced") { d.subgroup = "Condenados parcialmente" }
            else if (d.subgroup == "PRCS Revocation 3455") { d.subgroup = "Violación de la supervisión: revocación de la supervisión comunitaria después de la liberación" }
            else if (d.subgroup == "Parole Revocation 3000.08 FPC") { d.subgroup = "Violación de supervisión: revocación de la libertad condicional" }
            else if (d.subgroup == "County Sentenced N3") { d.subgroup = "Condenados totalmente: condenados del condado por un delito de la ley AB 109" }
        })

        let data = aobdata;

        updateGraph(aobdata)

        d3.selectAll(".genderbuttonf").on("click", function () {
            var section = d3.select(this).attr("id");
            if (d3.select(this).classed("selected")) {
            } else {
                d3.selectAll(".genderbuttonf").classed("selected", false);
                d3.select(this).classed("selected", true);
            }
            if (section == 'All') { data = aobdata } else {
                data = aobdata.filter(function (d) { return d.sex == section })
            }

            updateGraph(data);
        })

        data = aobdata.filter(function (d) { return d.sex == 'Females' })
        updateGraph(aobdata);
        downloadData('data-ab109', aobdata, 'ab109data.csv')


    });

function updateGraph(selectedData) {

    const newdata = d3.nest()
        .key(d => d.date)
        .key(d => d.subgroup)
        .rollup(v => d3.sum(v, d => d.value))
        .entries(selectedData);

    const flattenData = newdata.flatMap((item, i) => {
        const date = item.key;
        return item.values.map(level => ({
            date: date,
            level: level.key,
            value: level.value
        }));
    });

    const data = d3.nest()
        .key(d => d["date"])
        .sortKeys(d3.ascending)
        .rollup(function (d) {
            return d.reduce(function (prev, curr) {
                prev["date"] = curr["date"];
                prev[curr["level"]] = curr["value"];
                return prev;
            }, {});
        })
        .entries(flattenData)
        .map(d => d.value)

    color.domain(d3.keys(data[0]).filter(function (key) {
        return key !== "date" && key !== "sex" && key !== "_id";
    }));

    data.forEach(function (d) {
        d.date = parseTime(d.date);
    });
    data.sort((a, b) => a.date - b.date)

    var levels = color.domain().map(function (name) {
        return {
            name: name,
            values: data.map(function (d) {
                return {
                    date: d.date,
                    value: +d[name]
                };
            })
        };
    });

    x.domain(d3.extent(data, d => d.date))
    y.domain([
        d3.min(levels, function (c) {
            return d3.min(c.values, function (v) {
                return v.value;
            });
        }),
        d3.max(levels, function (c) {
            return d3.max(c.values, function (v) {
                return v.value + 20;
            });
        })
    ]);

    var lines = g.selectAll(".line")
        .data(levels)

    lines.enter().append("path")
        .attr("class", "line");

    lines.transition().duration(750)
        .style("stroke", d => color(d.name))
        .style('stroke-width', 2.5)
        .attr("id", d => d.level)
        .attr("d", d => line(d.values))

    lines.exit().remove();

    // var labs = g.selectAll('.label')
    //     .data(levels)

    // labs.enter().append('text')
    //     .attr('class', 'label')

    // labs.transition().duration(0)
    //     .attr('fill', '#000')
    //     .attr("x", width)
    //     .attr("y", d => y(d.values[d.values.length - 1].value) - 2)
    //     .text(function (d) {
    //         if (d.name == "PRCS Revocation 3455") { return "Supervision violation – post-release community supervision (PRCS) revocation" }
    //         else if (d.name == "Parole Revocation 3000.08 FPC") { return "Supervision violation – parole revocation" }
    //         else if (d.name == "N3 Partially Sentenced") { return "Partially Sentenced" }
    //         else if (d.name == "Flash Incarceration 3454") { return "Supervision violation – flash incarceration" }
    //         else { return d.name }
    //     })

    // labs.exit().remove()

    svg.selectAll(".axis").remove();

    g.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis);

    g.append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".71em")
        .style("text-anchor", "end")
        .text("Value (USD)");

    var legend = g.selectAll(".legend")
        .data(levels);

    legend.enter().append("rect")
        .attr("width", 10)
        .attr("height", 10)
        .attr("x", 0)
        .attr("y", function (d, i) { return (height + 40) + i * 20; })
        .attr("fill", function (d) {
            return color(d.name);
        })

    legend.enter().append("text")
        .attr("x", 15)
        .attr("y", function (d, i) { return (height + 50) + i * 20; })
        .attr('font-family', 'GT Walsheim Regular')
        .attr('font-size', 16)
        .attr("class", "legend");

    legend.transition()
        .style("fill", "#777")
        .text(d => d.name)

    legend.exit().remove();

    // tooltips
    const overlay = g.append('rect'),
        focus = g.append('g').attr("class", "focus")

    var mainTooltip = d3.select("body").append("div")
        .attr("class", "mainTooltip");

    focus
        .style("display", "none");

    focus.append("rect")
        .attr('x', -.5)
        .attr('y', 0)
        .attr('width', 1)
        .attr('height', height)
        .attr('fill', '#666')

    overlay
        .attr("class", "overlay")
        .attr("width", width)
        .attr("height", height)
        .on("mouseover", function () {
            focus.style("display", null);
        })
        .on("mouseout", function () {
            focus.style("display", "none");
            mainTooltip.style("visibility", "hidden");
        })
        .on("mousemove", mousemove);

    function mousemove() {
        var main_hover = d3.select('.main-hover')
        main_hover.attr("y", event.pageY - 140 + "px").attr('x', 0)

        var x0 = x.invert(d3.mouse(this)[0]),
            i = bisectDate(data, x0, 1),
            d0 = data[i - 1],
            d1 = data[i],
            d = x0 - d0.date > d1.date - x0 ? d1 : d0;

        var formatTime = d3.timeFormat("%m/%d/%Y");

        focus.attr("transform", "translate(" + x(d.date) + "," + 0 + ")");

        let tooltip_str = formatTime(d.date) + "<br/>" +
            "<div class='tooltip-label' style='background:#ef4136;'></div>Condenados totalmente: condenados del condado por un delito de la ley AB 109: " + addCommas(d['Condenados totalmente: condenados del condado por un delito de la ley AB 109']) + '<br/>' +
            "<div class='tooltip-label' style='background:#BCBDBC;color:#000;'></div>Violación de la supervisión: revocación de la supervisión comunitaria después de la liberación: " + addCommas(d['Violación de la supervisión: revocación de la supervisión comunitaria después de la liberación']) + '<br/>' +
            "<div class='tooltip-label' style='background:#231F20;'></div>Violación de supervisión: revocación de la libertad condicional: " + addCommas(d['Violación de supervisión: revocación de la libertad condicional']) + '<br/>' +
            "<div class='tooltip-label' style='background:#DAD9D5;color:#000;'></div>Condenados parcialmente: " + addCommas(d['Condenados parcialmente']) + '<br/>' +
            "<div class='tooltip-label' style='background:#4D4E56;'></div>Violación de supervisión: encarcelamiento “flash”: " + addCommas(d['Violación de supervisión: encarcelamiento “flash”'])

        mainTooltip
            .style('left', (pageWidth - (width + margin.right + margin.left)) / 2 + (margin.left / 2) + 5 + x(d.date) + 'px')
            .style("top", event.pageY - 140 + "px").attr('x', 0)
            .html(tooltip_str)
            .style("visibility", "visible")

    }

    // Define responsive behavior
    // function resize() {
    //     var width =
    //         parseInt(d3.select("#ab109-chart").style("width")) - margin.left - margin.right,
    //         height =
    //         parseInt(d3.select("ab109-chart").style("height")) -
    //         margin.top -
    //         margin.bottom;

    //     x.range([0, width]);
    //     y.range([height, 0]);

    //     svg
    //         .select(".x.axis")
    //         .attr("transform", "translate(0," + height + ")")
    //         .call(xAxis);

    //     svg.select(".y.axis").call(yAxis);

    //     svg.selectAll(".line").attr("d", d => line(d.values));

    //     svg.selectAll('.label')
    //     .attr('x',width)
    //     .attr("y", d => y(d.values[d.values.length-1].value) - 2)

    //     xAxis.ticks(Math.max(width / 100, 2));
    //     yAxis.ticks(Math.max(height / 50, 2));
    // }

    // d3.select(window).on("resize", resize);

    // resize();


}



